import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import { surveySelector } from "../../redux/surveySlice";
import StepControl from "../survey-form/StepControl";
import Stepper from "../survey-form/Stepper";
import SurveyForm from "../survey-form/SurveyForm";

const InspectionModal = (props) => {
  const ref = useRef();
  const [active, setActive] = useState("addInfo");
  const { inspection } = useSelector(surveySelector);

  return (
    <>
      <Modal
        {...props}
        onHide={() => {
          props.onHide();
          setActive("addInfo");
        }}
        aria-labelledby="contained-modal-title-vcenter"
        className="modalDrawer"
      >
        <Modal.Header closeButton>
          <div className="w-100 d-flex align-items-center">
            <Modal.Title id="contained-modal-title-vcenter">
              Building #
              {props.index !== -1
                ? props.index + 1
                : inspection
                ? inspection.length + 1
                : "1"}
            </Modal.Title>
            <button
              className="btn text-white"
              onClick={() => {
                props.onHide();
                setActive("addInfo");
              }}
            >
              Cancel
            </button>
          </div>
          <Stepper active={active} setActive={(e) => setActive(e)} />
        </Modal.Header>
        <SurveyForm ref={ref} active={active} />
        <StepControl
          active={active}
          index={props.index}
          setActive={(e) => setActive(e)}
          onClose={() => {
            props.onHide();
            setActive("addInfo");
          }}
          ref={ref}
        />
      </Modal>
    </>
  );
};

export default InspectionModal;
